import { __extends } from "tslib";
import { AbstractMethodError, AssetBase, Transform, TransformEvent } from '@awayjs/core';
import { LightEvent } from '../events/LightEvent';
var LightBase = /** @class */ (function (_super) {
    __extends(LightBase, _super);
    function LightBase(transform) {
        if (transform === void 0) { transform = null; }
        var _this = _super.call(this) || this;
        _this._color = 0xffffff;
        _this._colorR = 1;
        _this._colorG = 1;
        _this._colorB = 1;
        _this._ambientColor = 0xffffff;
        _this._ambient = 0;
        _this._specular = 1;
        _this._diffuse = 1;
        _this._shadowsEnabled = false;
        _this._ambientR = 0;
        _this._ambientG = 0;
        _this._ambientB = 0;
        _this._specularR = 1;
        _this._specularG = 1;
        _this._specularB = 1;
        _this._diffuseR = 1;
        _this._diffuseG = 1;
        _this._diffuseB = 1;
        _this._onInvalidateConcatenatedMatrix3DDelegate = function (event) { return _this._onInvalidateConcatenatedMatrix3D(event); };
        _this.transform = transform || new Transform();
        return _this;
    }
    Object.defineProperty(LightBase.prototype, "transform", {
        get: function () {
            return this._transform;
        },
        set: function (value) {
            if (this._transform == value)
                return;
            if (this._transform)
                this._transform.removeEventListener(TransformEvent.INVALIDATE_MATRIX3D, this._onInvalidateConcatenatedMatrix3DDelegate);
            this._transform = value;
            if (this._transform)
                this._transform.addEventListener(TransformEvent.INVALIDATE_MATRIX3D, this._onInvalidateConcatenatedMatrix3DDelegate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LightBase.prototype, "shadowsEnabled", {
        get: function () {
            return this._shadowsEnabled;
        },
        set: function (value) {
            if (this._shadowsEnabled == value)
                return;
            this._shadowsEnabled = value;
            if (value && this._shadowMapper == null) {
                this._shadowMapper = this._createShadowMapper();
                this._shadowMapper.light = this;
            }
            else if (!value) {
                this._shadowMapper.dispose();
                this._shadowMapper = null;
            }
            this.dispatchEvent(new LightEvent(LightEvent.CASTS_SHADOW_CHANGE));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LightBase.prototype, "specular", {
        get: function () {
            return this._specular;
        },
        set: function (value) {
            if (value < 0)
                value = 0;
            this._specular = value;
            this._updateSpecular();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LightBase.prototype, "diffuse", {
        get: function () {
            return this._diffuse;
        },
        set: function (value) {
            if (value < 0)
                value = 0;
            this._diffuse = value;
            this._updateDiffuse();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LightBase.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value) {
            this._color = value;
            this._colorR = ((this._color >> 16) & 0xff) / 0xff;
            this._colorG = ((this._color >> 8) & 0xff) / 0xff;
            this._colorB = (this._color & 0xff) / 0xff;
            this._updateDiffuse();
            this._updateSpecular();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LightBase.prototype, "ambient", {
        get: function () {
            return this._ambient;
        },
        set: function (value) {
            if (value < 0)
                value = 0;
            else if (value > 1)
                value = 1;
            this._ambient = value;
            this._updateAmbient();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LightBase.prototype, "ambientColor", {
        get: function () {
            return this._ambientColor;
        },
        set: function (value) {
            if (this._ambientColor == value)
                return;
            this._ambientColor = value;
            this._updateAmbient();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LightBase.prototype, "shadowMapper", {
        get: function () {
            this.shadowsEnabled = true; //ensure shadows are enabled on light
            return this._shadowMapper;
        },
        set: function (value) {
            if (this._shadowMapper == value)
                return;
            this._shadowMapper = value;
            this._shadowMapper.light = this;
        },
        enumerable: false,
        configurable: true
    });
    // public _getEntityProjectionMatrix(entity:IEntity, cameraTransform:Matrix3D, target:Matrix3D = null):Matrix3D
    // {
    // 	throw new AbstractMethodError();
    // }
    LightBase.prototype._createShadowMapper = function () {
        throw new AbstractMethodError();
    };
    LightBase.prototype._updateSpecular = function () {
        this._specularR = this._colorR * this._specular;
        this._specularG = this._colorG * this._specular;
        this._specularB = this._colorB * this._specular;
    };
    LightBase.prototype._updateDiffuse = function () {
        this._diffuseR = this._colorR * this._diffuse;
        this._diffuseG = this._colorG * this._diffuse;
        this._diffuseB = this._colorB * this._diffuse;
    };
    LightBase.prototype._updateAmbient = function () {
        this._ambientR = ((this._ambientColor >> 16) & 0xff) / 0xff * this._ambient;
        this._ambientG = ((this._ambientColor >> 8) & 0xff) / 0xff * this._ambient;
        this._ambientB = (this._ambientColor & 0xff) / 0xff * this._ambient;
    };
    LightBase.prototype._onInvalidateConcatenatedMatrix3D = function (event) {
        //do nothing - to be overridden
    };
    return LightBase;
}(AssetBase));
export { LightBase };
